import React from 'react';

const pageNotFound = (props) => {
  return <div style={{ textAlign: 'center', marginTop: '100px' }}>
    <h1 style={{ marginBottom: '15px' }}>Page not found</h1>
    <p>The page you navigated to does not exist</p>
  </div>
}

export default pageNotFound;


// WEBPACK FOOTER //
// ./src/components/miscUtility/PageNotFound/PageNotFound.jsx